/* unplugin-vue-components disabled */import { render } from "./ZoomSVG.vue?vue&type=template&id=449c7ef8"
import script from "./ZoomSVG.vue?vue&type=script&lang=js"
export * from "./ZoomSVG.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__